"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectLegacyDashboards = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.legacyDashboards; });
/**
 * Selects all the legacy dashboards. Invocations before initialization lead to invariant errors.
 *
 * @alpha
 */
exports.selectLegacyDashboards = toolkit_1.createSelector(selectSelf, function (state) {
    ts_invariant_1.default(state.legacyDashboards, "attempting to access uninitialized legacy dashboard state");
    return state.legacyDashboards;
});
//# sourceMappingURL=legacyDashboardsSelectors.js.map